import { trackAnalyticsNew } from '../../../../lib/utils';

export const getBrowseCategoriesLevelThreeAnalytics = ({
  analyticsSlug,
  parentCategoryAnalyticsSlug,
  url,
}) => trackAnalyticsNew({
  url,
  location: `page:header-nav:level-3:browse-categories:${parentCategoryAnalyticsSlug || ''}`,
  name: analyticsSlug,
});

export const getAllCategoryAnalyticsSlug = (parentCategoryAnalyticsSlug) => (
  parentCategoryAnalyticsSlug ? `all-${parentCategoryAnalyticsSlug}` : ''
);

export const getShopImageAnalyticsSlug = (shopSlug) => (
  shopSlug ? `${shopSlug}-image` : ''
);
